module.exports = __webpack_public_path__ + "static/media/lady on bench.9c6df47f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/lady on bench.jpg
// module id = 417
// module chunks = 0